import React, { VFC } from 'react';
import { ClientSideWizardFlowPresenter } from '../../../../content-composer/src/components/ClientSideWizard/ClientSideWizardFlowPresenter';
import { useApproveRejectPayrollFlowConfig } from './useApproveRejectPayrollFlowConfig';

export interface ApproveRejectPayrollFlowPresenterProps {
  authAction: string | null;
  onToggleDrawer: () => void;
}

const payrollFlowPreloadedData = {
  data: {
    rejectReasonStep: {
      stepId: 'rejectReasonStep',
      values: {},
    },
    payrollInitiate: {
      stepId: 'payrollInitiate',
      values: {},
    },
    payrollExecute: {
      stepId: 'payrollExecute',
      values: {},
    },
  },
};

const ApproveRejectPayrollFlowPresenter: VFC<ApproveRejectPayrollFlowPresenterProps> = ({
  authAction,
  onToggleDrawer,
}) => {
  const flowConfig = useApproveRejectPayrollFlowConfig(authAction, onToggleDrawer);

  if (authAction === null) {
    return null;
  }

  return (
    <ClientSideWizardFlowPresenter
      processName={'payroll-flow'}
      preloadedFormDataConfig={payrollFlowPreloadedData}
      stepsConfig={flowConfig.data}
      isTakeover={true}
      shouldEnablePaddingBottom={false}
    />
  );
};

export { ApproveRejectPayrollFlowPresenter };
